import React from "react";
import InvestorSection from "../../components/Investor/Investor.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";

const Investor = () => {
  return (
    <>
      <MetaComponent
        title="Financials and Investor news of Aptech – leader in skill-based training in India"
        desc="Get all updates on Aptech's shareholder pattern, investor relations, latest news, investor communication policy, financial results and annual reports."
        keywords="Investor news of Aptech, Aptech Investor Relations, Investor Policies"
      />
     
      <InvestorSection />
    </>
  );
};

export default Investor;
